import fetch from "auth/FetchInterceptor";

const NotyetreleasedService = {};
NotyetreleasedService.index = function (payload) {
  return fetch({
    url:
      "/reports/orders-not-released?" +
      "startdate=" +
      payload.startDate +
      "&enddate=" +
      payload.endDate +
      "&agency=" +
      payload.agency +
      "&department=" +
      payload.department,
    method: "get",
  });
};
export default NotyetreleasedService;
